import ApiPbxClient from "@/api/ApiPbxClient";
import { getTextColorForBackground } from "@/utils/colors";
import { QUEUE_TYPES } from "@/utils/constants";

const SAMPLE_QUEUES = (wgId) => [
  {
    id: 1,
    wgId,
    name: "normal",
    weight: 1,
    color: "#FFFFFF",
    agent_eligible: 1,
    data: {
      displayName: "Normal",
    },
    deleted: null,
  },
  {
    id: 2,
    wgId,
    name: "hold",
    weight: 0,
    color: "#FF99CC",
    agent_eligible: 0,
    data: {
      displayName: "Espera",
    },
    deleted: null,
  },
  {
    id: 3,
    wgId,
    name: "transfer",
    weight: 0,
    color: null,
    agent_eligible: 0,
    data: {
      displayName: "Transferencia",
    },
    deleted: null,
  },
  {
    id: 4,
    wgId,
    name: "usual",
    weight: 2,
    color: "#FFB366",
    agent_eligible: 1,
    data: {
      displayName: "Habitual",
    },
    deleted: null,
  },
  {
    id: 5,
    wgId,
    name: "vip",
    weight: 3,
    color: "#85E085",
    agent_eligible: 1,
    data: {
      displayName: "VIP",
    },
    deleted: null,
  },
  {
    id: 6,
    wgId,
    name: "noanswer",
    weight: 0,
    color: "#FF6666",
    agent_eligible: 1,
    data: {
      displayName: "No coger",
    },
    deleted: null,
  },
];

const state = {
  queues: {},
};

const mutations = {
  setQueues(state, { queues, wgId }) {
    state.queues[wgId] = queues;
  },
};

const actions = {
  async loadQueues({ commit }, wgId) {
    const params = {
      wgId,
      mode: "operator",
    };
    try {
      const api = ApiPbxClient();
      let response = await api.get("queues", { params });
      const queues = { wgId, queues: response.data };
      commit("setQueues", queues);
    } catch (error) {
      console.error("ERROR on getQueues: ", error.message);
    }
  },
  async saveQueues({ rootGetters }, queues) {
    const params = {
      wgId: rootGetters["app/defaultWorkgroup"].id,
    };
    try {
      const api = ApiPbxClient();
      await api.put("queues", queues, { params });
    } catch (error) {
      console.error("ERROR on saveQueues: ", error.message);
      throw error;
    }
  },
};

const getters = {
  queues(state, _getters, _, rootGetters) {
    const withFallback =
      state.queues[rootGetters["app/defaultWorkgroup"].id] ||
      SAMPLE_QUEUES(rootGetters["app/defaultWorkgroup"].id);
    return withFallback;
  },
  agentEligibleQueues(state) {
    return (wgId) => {
      const withFallback = state.queues[wgId] || SAMPLE_QUEUES(wgId);
      return withFallback.filter((q) => !q.deleted && q.agent_eligible);
    };
  },
  getQueue(state) {
    return (id, wgId) => {
      const withFallback = state.queues[wgId] || SAMPLE_QUEUES(wgId);
      return withFallback.find((q) => q.id === id);
    };
  },
  getQueueTextColor(_state, getters) {
    return (id, wgId) => {
      return getTextColorForBackground(getters.getQueue(id, wgId)?.color || "#ffffff");
    };
  },
  getQueueDisplayName(_state, getters) {
    return (id, wgId) => {
      const queue = getters.getQueue(id, wgId);
      return (
        queue?.data?.displayName ||
        QUEUE_TYPES.find((t) => t.key === queue.name)?.name ||
        queue?.name ||
        "-"
      );
    };
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
